import { RfxMailLayoutProps } from "../types/RfxMailLayoutProps.interface";

const data_get = (
	obj: any,
	key: string,
	defaultValue: string | null = null
) => {
	if (!obj) {
		return defaultValue;
	}
	const value =
		key.split(".").reduce((o, k) => (o || {})[k], obj) || defaultValue;
	return value;
};

export const RFxMailLayout: React.FC<RfxMailLayoutProps> = ({
	$supplier_contact_name,
	$contact,
	rfx_type,
	project_name,
	rfx_title,
	children,
	isOnboarding = false,
}) => {
	const $email = data_get($contact, "contact_email");
	return (
		<table
			width="100%"
			style={{ backgroundColor: "#ffffff" }}
		>
			<tr>
				<td align="center">
					<table
						width="600"
						style={{ maxWidth: "600px" }}
					>
						<tr>
							<td style={{ padding: "40px 0px" }}>
								<table
									cellPadding="0"
									cellSpacing="0"
									width="100%"
								>
									<tr>
										<td
											style={{
												fontFamily: "Arial, sans-serif",
												fontSize: "16px",
												lineHeight: "24px",
												color: "#1F2937",
												paddingBottom: "24px",
											}}
										>
											{isOnboarding ? "Hi" : "Dear"}{" "}
											{$supplier_contact_name ?? "[Recipient(s) Name]"}
										</td>
									</tr>
									{children}
									{isOnboarding ? (
										<tr>
											<td
												style={{
													fontFamily: "Arial, sans-serif",
													fontSize: "16px",
													lineHeight: "24px",
													color: "#374151",
												}}
											>
												<br />
												Best Regards,
												<br />
												<br />
												<b>The Procuracon Team</b>
												<br />
												<i>Supporting transparent and efficient procurement</i>
											</td>
										</tr>
									) : (
										<tr>
											<td
												style={{
													fontFamily: "Arial, sans-serif",
													fontSize: "16px",
													lineHeight: "24px",
													color: "#374151",
												}}
											>
												<br />
												Best Regards,
												<br />
												<br />
												{data_get($contact, "contact_name", "-") ?? "-"}
												<br />
												{data_get($contact, "contact_position", "-") ?? "-"}
												<br />
												<br />
												<a
													href={`mailto:${$email}?subject=${rfx_type} | ${project_name} | ${rfx_title}`}
												>
													{$email}
												</a>
												<br />
												{data_get($contact, "contact_phone_number", "-") ?? "-"}
											</td>
										</tr>
									)}
								</table>
							</td>
						</tr>
					</table>
				</td>
			</tr>
		</table>
	);
};
